import { render, staticRenderFns } from "./NavigationSideFooter.vue?vue&type=template&id=0bfc3332&scoped=true"
import script from "./NavigationSideFooter.vue?vue&type=script&lang=js"
export * from "./NavigationSideFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc3332",
  null
  
)

export default component.exports